import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";

export {
  CountBadge,
  EmptyHint,
  IconSlot,
  SectionHeader,
  SectionTitle,
  TabRoot,
} from "../KgInspectorTablesTab/KgInspectorTablesTab.styles";

export const LinkRowStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;
